// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../action-list';
import {createAllClaimsPayload} from '../services/all-claims-payload';
import {getAllClaimResults} from '../../shared/repositories';
import {readExcelLayouts} from '../../../shared/action-creators/read-excel-layouts';

export const openAccordion = accordionId => ({
    accordionId,
    type: actions.OPEN_ALL_CLAIMS_ACCORDION
});

export const readAllClaims = (isInitialLoad, showDealerInvoice) =>

    async (dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        const facets = getState().claims.allClaims.facets;

        const payload = createAllClaimsPayload(facets, '', '', showDealerInvoice);

        const dateRange = facets.claimDateRangeFacet.dateRange;

        try {

            const allClaimsResults = await getAllClaimResults(payload);

            dispatch({
                data: allClaimsResults,
                type: actions.UPDATE_ALL_CLAIM_SEARCH_RESULTS_SUCCESS
            });

            if (isInitialLoad) {

                dispatch({
                    dateRange,
                    type: actions.UPDATE_ALL_CLAIMS_DATE_RANGE_FACET
                });

            }

            if (!getState().exportToExcel.selectedExcelLayout.claims.name) {

                readExcelLayouts('claims')(dispatch);

            }

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const toggleAccordion = (accordionId, list) => ({
    list: list.accordionList.map(item => item.accordionId === accordionId ? {
        accordionId: item.accordionId,
        isExpanded: !item.isExpanded
    } : {
        accordionId: item.accordionId,
        isExpanded: false
    }),
    type: actions.TOGGLE_ACCORDION
});

export const updateListFilterBy = filterBy => ({
    payload: filterBy,
    property: 'filterBy',
    type: actions.UPDATE_ALL_CLAIMS_SEARCH_FILTER_BY
});

export const updateListSortBy = sortBy => ({
    payload: sortBy,
    property: 'sortBy',
    type: actions.UPDATE_ALL_CLAIMS_SEARCH_SORT_BY
});

export const updateListSortDirection = sortDirection => ({
    payload: sortDirection,
    property: 'sortDirection',
    type: actions.UPDATE_ALL_CLAIMS_SEARCH_SORT_DIRECTION
});



// WEBPACK FOOTER //
// ./src/claim/all-claims/action-creators/all-claims.js